export default "/images/efdba099327e2d8d20db93cfbdc34c07.avif";